<template>
  <el-card
    shadow="never"
    class="metric-widget"
    :class="`metric-widget--${status}`"
  >
    <div class="metric-widget__header">
      <span class="metric-widget__label">{{ label }}</span>
      <span
        v-if="icon"
        class="metric-widget__icon"
      >
        <FontAwesomeIcon
          :icon="icon"
          fixed-width
        />
      </span>
    </div>
    <div class="metric-widget__value">
      {{ value }}
    </div>
    <small
      v-if="helper"
      class="metric-widget__helper"
    >
      {{ helper }}
    </small>
  </el-card>
</template>

<script>
const STATUSES = ['default', 'info', 'success', 'warning', 'danger']

export default {
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      required: true
    },
    helper: {
      type: String,
      default: ''
    },
    icon: {
      type: [String, Array],
      default: null
    },
    status: {
      type: String,
      default: 'default',
      validator: value => STATUSES.includes(value)
    }
  }
}
</script>

<style lang="scss" scoped>
.metric-widget {
  border-top: 3px solid #909399;
  min-height: 118px;

  &--info {
    border-top-color: #315bac;
  }

  &--success {
    border-top-color: #2f8f6b;
  }

  &--warning {
    border-top-color: #c17a00;
  }

  &--danger {
    border-top-color: #c44747;
  }
}

.metric-widget__header {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.metric-widget__label,
.metric-widget__helper {
  color: #7a818c;
}

.metric-widget__label {
  font-size: 12px;
  font-weight: 600;
}

.metric-widget__icon {
  align-items: center;
  background: #f0f2f5;
  border-radius: 4px;
  color: #607087;
  display: inline-flex;
  height: 28px;
  justify-content: center;
  width: 28px;
}

.metric-widget__value {
  color: #252d38;
  font-size: 24px;
  line-height: 1.2;
  margin-top: 5px;
}

.metric-widget__helper {
  display: block;
  font-size: 11px;
  margin-top: 7px;
}
</style>
